/* eslint-disable no-redeclare */
class AuthenticationError extends Error {
  /** Error type */
  type: AuthenticationError.Type;

  constructor(type: AuthenticationError.Type = AuthenticationError.Type.general, ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthenticationError);
    }

    this.name = "AuthenticationError";
    // Custom debugging information
    this.type = type;
  }
}

namespace AuthenticationError {
  export enum Type {
    /** A general JavaScript error */
    general,
    /** Getting a new Cognito token failed */
    getCognitoTokenFailed,
    /** No authenticated AWS Cognito user */
    noAuthenticatedCognitoUser,
    /** Getting a new AWS Cognito user failed */
    getCognitoUserFailed = "Getting a new Cognito",
    /** Getting the user info of an AWS Cogntio user */
    getCurrentUserInfoFailed = "getCurrentUserInfoFailed",
    /** Signout a user with AWS Cognito failed */
    awsAuthSignOutFailed = "awsAuthSignOutFailed",
    /** Getting a new Ktzn access token failed */
    noKtznAccessToken = "Getting the Kotozna access token failed",
    /** Getting a new Ktzn refresh token failed */
    noKtznRefreshToken = "Getting the Kotozna refresh token failed",
    /** Auth SignIn failed */
    authSignInFailed = "authSignInFailed",
    /** Ktzn auth refresh failed */
    authRefreshFailed = "authRefreshFailed",
  }
}

export default AuthenticationError;
